import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Actions from '../../actions';
import { bindActionCreators } from 'redux';
import lang from '../../constants/Languages.js';

import mail from '../../assets/icons/mail.svg';
import mailAccentLight from '../../assets/icons/mail-accent-light.svg';
import mailContrast from '../../assets/icons/mail-contrast.svg';
import warning from '../../assets/icons/warning.svg';
import warningAccent from '../../assets/icons/warning-accent.svg';
import warningContrast from '../../assets/icons/warning-contrast.svg';
import menuDots from '../../assets/icons/menu-dots.svg';
import menuDotsAccent from '../../assets/icons/menu-dots-accent.svg';


class DetailsDesc extends Component {
	constructor() {
		super();
		this.state = {
			isMobile: false,
			isOpened: false
		};
	};

	componentDidMount() {
		this.updateDimensions();
		window.addEventListener("resize", this.updateDimensions);
	};

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	};

	updateDimensions = () => {
		this.setState({ isMobile: window.innerWidth <= 767 });
	};

	toggleDropdown = () => {
		this.setState({ isOpened: !this.state.isOpened });
	};

	getIcons = () => {
		const { detailsData, clang } = this.props;
		return [
			<li className="headings-details__desc__button-item" key={ 0 }>
				<a href={ `mailto:${detailsData.contact}` } className="headings-details__desc__button" title={ lang[ clang ].title.contact }>
					<img className="headings-details__desc__button-img" src={ mail } alt={ lang[ clang ].alt.csv } />
					<img className="headings-details__desc__button-img--accent" src={ mailAccentLight } alt={ lang[ clang ].alt.csv } />
					<img className="headings-details__desc__button-img contrast" src={ mailContrast } alt={ lang[ clang ].alt.csv } />
					<span className="headings-details__desc__button--text">{ lang[ clang ].headings_details.contact }</span>
				</a>
			</li>,
			<li className="headings-details__desc__button-item" key={ 1 }>
				<a href={ `mailto:${detailsData.contact}` } className="headings-details__desc__button" title={ lang[ clang ].title.error }>
					<img className="headings-details__desc__button-img" src={ warning } alt={ lang[ clang ].alt.csv } />
					<img className="headings-details__desc__button-img--accent" src={ warningAccent } alt={ lang[ clang ].alt.csv } />
					<img className="headings-details__desc__button-img contrast" src={ warningContrast } alt={ lang[ clang ].alt.csv } />
					<span className="headings-details__desc__button--text">{ lang[ clang ].headings_details.error }</span>
				</a>
			</li>
		].filter(icon => icon)
	};

	render() {
		const { clang, detailsData } = this.props;
		const { isMobile, isOpened } = this.state;

		if (!detailsData.description && !detailsData.shortDescription) {
			return null;
		}

		return (
			<div className="headings-details__desc--top">
				<div className="headings-details__desc__container">
					<h2 className="headings-details__desc__title"
						dangerouslySetInnerHTML={ { __html: lang[ clang ].headings_details.desc } }></h2>
					<div className="headings-details__desc__buttons-container">
						{ isMobile && this.getIcons().length > 1 &&
							<button className="headings-details__desc__button-trigger" onClick={ () => this.toggleDropdown() }>
								<img className="headings-details__desc__button-trigger__img" src={ menuDots } alt="" />
								<img className="headings-details__desc__button-trigger__img--accent" src={ menuDotsAccent } alt="" />
							</button> }
						{ (!isMobile || isOpened || (isMobile && this.getIcons().length <= 1)) &&
							<ul className={ `headings-details__desc__buttons ${isMobile && this.getIcons().length <= 1 ? 'single' : ''}` }>
								{ this.getIcons() }
							</ul> }

					</div>
				</div>
				<p className="headings-details__desc__content">
					{ detailsData.description ? detailsData.description : detailsData.shortDescription }
				</p>
			</div>
		);
	}
}

DetailsDesc.propTypes = {
	clang: propTypes.string.isRequired,
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
});

export default connect(mapStateToProps)(DetailsDesc);



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsDesc.js